<template>
  <div class="block-info block-level">
    <van-collapse v-model="activeNames">
      <van-collapse-item
        class="level-item"
        v-for="(item, index) in stages"
        :key="index"
        :name="index"
        :class="`${item.journeyStage.learningStatus}` === '2' ? 'item-ing' : ''"
      >
        <template #title>
          <div class="col-title" @click.stop.prevent="handleUnlock(item, index)">
            <template v-if="item.journeyStage.state === '1' && item.journeyStage.manualUnlockSign !== 1">
              <img src="@/assets/images/cartojourney/img39.png" class="icon-tag icon-ingjourney"
                   v-if="item.journeyStage.learningStatus === '2'" alt="">
              <img src="@/assets/images/cartojourney/img40.png" class="icon-tag icon-journey"
                   v-else-if="item.journeyStage.learningStatus === '3'" alt="">
              <img src="@/assets/images/cartojourney/img41.png" class="icon-tag icon-edjourney"
                   v-else-if="item.journeyStage.learningStatus === '1'" alt="">
            </template>
            <div class="state-name">
              {{
                item.journeyStage.stageNo.substring(0, 2) === "U4"
                  ? "U3"
                  : item.journeyStage.stageNo.substring(0, 2)
              }}
            </div>
            <div class="state-title">{{ item.journeyStage.name }}</div>
            <img
              v-if="item.journeyStage.state === '2'"
              src="@/assets/images/cartojourney/img34.png"
              class="icon-suo"
              alt="锁定"
            />
            <div
              class="edit-btn"
              v-if="(!hasVersionNumber || isSurgeon || allowEditing) && item.journeyStage.state === '1' && item.journeyStage.learningStatus !== '1'"
              @click.stop="handleEdit(item)"
            >
              编辑
            </div>
          </div>
        </template>
        <div class="tip" v-if="item.cycle">
          <span class="time-txt" v-if="item.cycle.growthCycle"
          >成长周期:{{ item.cycle.growthCycle }}M</span
          >
          <template v-if="item.journeyStage.manualUnlockSign !== 1">
            <span class="delay-day" v-if="item.cycle.completedTime">
              过关时间:{{
                $moment(item.cycle.completedTime * 1).format("YYYY-MM-DD")
              }}
            </span>
            <span class="delay-day" v-else-if="item.cycle.delayDay">
              <img src="@/assets/images/cartojourney/img42.png" class="icon-delay" alt="">
              已延迟：{{ item.cycle.delayDay }}天
            </span>
            <span class="delay-day" v-else-if="item.cycle.graduationTime">
              毕业时间:{{
                $moment(item.cycle.graduationTime * 1).format("YYYY-MM-DD")
              }}
            </span>
          </template>
        </div>
        <div class="tip"
             v-else-if="`${item.journeyStage.learningStatus}` === '1' && item.journeyStage.manualUnlockSign !== 1">
          <span class="time-txt"></span>
          <span class="delay-day" v-if="item.journeyStage.endTime">
            过关时间:{{
              $moment(item.journeyStage.endTime).format("YYYY-MM-DD")
            }}
          </span>
        </div>
        <div class="tip tip-standard">
          <span class="standard">升级标准</span>
          <span class="standard-txt">{{ item.journeyStage.evaluationCriteria }}</span>
        </div>
        <van-collapse class="level-course" v-model="activeCourse">
          <van-collapse-item
            v-if="item.studyContent && item.studyContent.length > 0"
            :name="`iEP学习${index}`"
          >
            <template #title>
              <div class="act-title">
                iEP学习
              </div>
            </template>
            <div class="list-act">
              <div
                class="item"
                v-for="(course, courseIndex) in item.studyContent"
                :key="courseIndex"
                @click="handleClick(course)"
              >
                <img
                  :src="course.docuCourseCase ? course.docuCourseCase.coverUrl : ''"
                  class="item-cover course-cover"
                  alt=""
                />
                <div class="item-cons">
                  <div class="cons-name">{{ course.docuCourseCase ? course.docuCourseCase.title : '' }}</div>
                  <div class="cons-flex">
                    <div class="flex-times" v-if="course.baseType != 1">
                      讲师: {{ course.docuCourseCase ? course.docuCourseCase.keynoteSpeaker : '' }}
                    </div>
                    <template>
                      <div class="status" v-if="`${course.learningStatus}` === '1'">已完成</div>
                      <div class="status" v-if="`${course.learningStatus}` === '2'">进行中</div>
                      <div class="status none" v-if="`${course.learningStatus}` === '3'">未开始</div>
                    </template>
                  </div>
                  <div class="item-unlock"
                       v-if="course.docuCourseCase && `${course.docuCourseCase.isUnlock}` === '1' && !course.docuCourseCase.myUnlock">
                    <img src="@/assets/images/cartojourney/img34.png" class="icon-unlock" alt="">
                    <span class="txt">可使用{{
                        course.docuCourseCase ? course.docuCourseCase.unlockCost : ''
                      }}积分兑换</span>
                  </div>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div v-else class="empty-div">
            <img src="../../../assets/images/zone/img18.png" class="empty-img" alt="" />
            <div class="empty-txt">暂无课程</div>
          </div>
        </van-collapse>
      </van-collapse-item>
    </van-collapse>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import {setSha, traceClickURL} from '../../../utils/util'
import {isScorm} from '../../../api/scorm'

export default {
  name: 'JourneyStageCollapse',
  props: {
    // 旅程阶段列表
    stages: {},
    customizedCode: {
      type: String,
      default: ''
    },
    // 是否有版本号
    hasVersionNumber: {
      default: 0
    },
    isSurgeon: {
      default: false
    },
    allowEditing: {
      default: false
    },
  },
  components: {
    dialogUnlock
  },
  computed: {
    userRole() {
      return sessionStorage.getItem('userRole')
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  data() {
    return {
      activeNames: [],
      activeCourse: [],
      dataProps: {
        unlockContent: '兑换个性化CJ课程',
        unlockTxt: '课程'
      },
      showActIndex: -1
    }
  },
  mounted() {
    this.activeNames = []
    this.activeCourse = []
    if (this.stages && this.stages.length > 0) {
      this.stages.map((res, index) => {
        if (`${res.journeyStage.state}` === '1') {
          this.activeNames.push(index)
          if (res.studyContent && res.studyContent.length > 0) {
            this.activeCourse.push(`iEP学习${index}`)
          }
        }
      })
    }
  },
  watch: {
    stages: {
      handler(newValue) {
        this.activeNames = []
        this.activeCourse = []
        if (newValue) {
          newValue.map((res, index) => {
            if (`${res.journeyStage.state}` === '1') {
              this.activeNames.push(index)
              if (res.studyContent && res.studyContent.length > 0) {
                this.activeCourse.push(`iEP学习${index}`)
              }
            }
          })
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    handleUnlock(item, index) {
      if (item.journeyStage.state === '2') {
        this.$emit('unlockJourneyStages', item)
      }
      if (item.journeyStage.state === '2') return
      if (!this.activeNames.includes(index)) {
        this.activeNames.push(index)
      } else {
        const i = this.activeNames.findIndex(i => i === index)
        this.activeNames.splice(i, 1)
      }
    },
    clickAct(index) {
      this.showActIndex = this.showActIndex === index ? -1 : index
    },
    async handleJump() {
      let item = this.dataDetails
      // 1文献 2课程 3病例
      window.sessionStorage.setItem('entrance', '56')
      switch (item.baseType) {
        case 1:
          this.$router.push({
            path: '/articleDetails',
            query: {
              id: item.courseId,
              businessId: this.customizedCode,
              entrance: '56',
              channel: '56'
            }
          })
          break
        case 2:
          const query = {
            courseId: item.courseId,
            businessId: this.customizedCode,
            entrance: '56',
            channel: '56'
          }
          const isscorm = await isScorm(item.courseId)
          let path = '/courserDetails'
          if (isscorm.data) {
            path = '/scormCourseDetail'
          }
          this.$router.push({path, query})
          break
        case 3:
          let trackParams = `&entrance=56&businessChannel=56&campId=${this.customizedCode}`
          let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
          setTimeout(() => {
            traceClickURL()
          })
          window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.courseId}${openidBindli}${trackParams}`
          break
      }
    },
    // 解锁
    handleClick(item, index) {
      if (`${this.userInfo.memberType}` === '0') {
        this.curIndex = index
        this.dataDetails = item
        if (item.docuCourseCase && `${item.docuCourseCase.isUnlock}` === '1' && !item.docuCourseCase.myUnlock) {
          this.dataProps.baseId = item.courseId
          this.dataProps.unlockCost = item.docuCourseCase.unlockCost
          this.$refs.dialogUnlock.dailogShow = true
          return
        }
        this.handleJump()
      }
    },
    handleEdit(item) {
      this.$emit('edit', item) // 触发父组件的 edit 事件
    }
  }
}
</script>
<style lang="less" scoped>
.empty-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .empty-img {
    width: 185px;
    margin-bottom: 4px;
  }
  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
.block-info {
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 12px;

  .title {
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    padding-left: 15px;
    position: relative;
    margin-top: 16px;
    margin-bottom: 15px;

    &::before {
      position: absolute;
      left: 5px;
      width: 4px;
      height: 12px;
      border-radius: 4px;
      background-color: #EB1700;
      top: 50%;
      transform: translateY(-50%);
      content: "";
    }
  }

  .block-con {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    padding: 17px 24px;
    padding-bottom: 1px;
    box-sizing: border-box;

    .con-info {
      display: flex;
      position: relative;
      margin-bottom: 16px;

      &::before {
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #d8d8d8;
        left: -10px;
        top: 7px;
        content: "";
      }

      .label {
        font-size: 12px;
        color: #333333;
        line-height: 17px;
        width: 120px;
      }

      .val {
        font-size: 12px;
        color: #333333;
        width: 200px;
        line-height: 17px;

        &.border {
          width: 58px;
          height: 17px;
          border-radius: 100px;
          border: 1px solid #EB1700;
          text-align: center;
        }
      }
    }
  }
}

.block-level {
  padding: 0 10px;
  padding-top: 0;
  box-sizing: border-box;

  /deep/ .level-item {
    padding: 16px 0;
    padding-left: 6px;
    padding-right: 12px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 12px;
    border-radius: 8px;
    position: relative;
    cursor: pointer;

    &.item-ing {
      // border-left: 7px solid #EB1700;
      &::after {
        content: '';
        border-left: 6px solid #EB1700;
        left: 0;
        top: 0;
        position: absolute;
        height: 100%;
        transform: none;
        border-radius: 8px;
      }
    }

    .icon-tag {
      position: absolute;
      width: 44px;
      left: 14px;
      top: -23px;
      z-index: 999;

      &.icon-ingjourney {
        width: 35px;
      }
    }

    .van-cell {
      overflow: visible;

      &::after {
        border: none;
      }

      .van-icon-arrow {
        position: relative;
        top: 2px;
      }
    }

    .col-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #000;

      .state-name {
        margin-right: 6px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #eb1700;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-weight: 500;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
      }

      .state-title {
        flex: 1;
      }

      .icon-suo {
        width: 16px;
        margin-right: 6px;
      }

      .edit-btn {
        width: 56px;
        text-align: center;
        border: 1px solid #eb1700;
        border-radius: 100px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
        font-weight: 400;
        height: 22px;
        line-height: 22px;
        color: #eb1700;
        margin-right: 4px;
      }
    }

    .van-collapse-item__wrapper {
      padding-left: 34px;
      box-sizing: border-box;
    }

    &::before {
      position: absolute;
      left: 21px;
      border-left: 1px dashed #979797;
      content: "";
      height: calc(100% - 56px);
      top: 40px;
      transform: inherit;
    }

    /deep/ .van-cell__title {
      font-size: 16px;
      color: #000;
      font-weight: 500;
    }

    .act-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      display: flex;
      align-items: center;

      .icon-tip-div {
        width: 13px;
        display: block;
        margin-left: 10px;
        position: relative;

        .icon-tip {
          display: block;
          width: 13px;
        }

        .handle-Act {
          position: absolute;
          background-image: url('../../../assets/images/cartojourney/img44.png');
          width: 238px;
          height: 56px;
          top: -56px;
          left: -60px;
          background-size: 100%;
          background-repeat: no-repeat;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 13px;
          font-weight: 400;
          line-height: 18px;
          color: #FFFFFF;
          padding: 0 14px;
          padding-top: 5px;
          box-sizing: border-box;
        }
      }
    }

    .level-title {
      display: flex;
      font-size: 12px;
      color: #333333;
      margin-top: 9px;
      margin-bottom: 15px;

      .level-txt {
        margin-right: 10px;

        .img-txt {
          width: 53px;
          height: 19px;
        }
      }

      .icon-title {
        width: 53px;
        height: 20px;
        margin-right: 3px;
      }
    }

    .tip {
      font-size: 12px;
      color: #eb1700;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;

      &.tip-standard {
        justify-content: flex-start;

        .standard {
          background: rgba(235, 23, 0, 0.05);
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #EB1700;
          width: 50px;
          min-width: 50px;
          max-width: 50px;
          height: 16px;
          color: #EB1700;
          font-size: 10px;
          margin-right: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .standard-txt {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }
      }

      .delay-day {
        display: flex;
        align-items: center;

        .icon-delay {
          width: 12px;
          display: block;
          margin-right: 5px;
        }
      }
    }

    .level-course {
      border-radius: 3px;
      position: relative;

      &::after {
        border: none;
      }

      .van-cell__title {
        font-size: 12px;
        color: #333333;
      }

      .van-cell {
        background: transparent;
      }

      .van-collapse-item__wrapper {
        padding-left: 0;
      }

      .van-collapse-item {
        margin-bottom: 8px;
        padding: 6px;
        box-sizing: border-box;
        z-index: 9;

        &::before {
          border-radius: 3px;
          background: linear-gradient(90.00deg, rgb(213, 207, 201),rgb(249, 248, 247) 100%);
          opacity: 0.17;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: -1;
          content: "";
        }

        &::after {
          border: none;
        }

        &:nth-last-child(1) {
          margin-bottom: 0;
        }

        .van-collapse-item__content {
          background: transparent;
        }
      }

      .list-act {
        max-height: 320px;
        overflow-y: scroll;

        .item {
          display: flex;
          align-items: center;
          padding: 8px 4px;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 4px;
          margin-top: 8px;

          .item-cover {
            width: 32px;
            height: 32px;
            display: block;
            margin-right: 2px;

            &.course-cover {
              width: 72px;
              height: 40px;
              object-fit: cover;
            }
          }

          .item-cons {
            display: flex;
            flex-direction: column;
            flex: 1;

            .cons-name {
              font-family: PingFang HK, PingFang HK;
              font-weight: 500;
              font-size: 13px;
              color: #000000;
            }

            .cons-flex {
              display: flex;
              justify-content: space-between;
              flex: 1;
              height: 20px;

              .flex-times {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-size: 13px;
                color: #b1b1b1;
                display: -webkit-box;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                flex: 1;
                width: calc(100% - 46px);
              }

              .status {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-size: 12px;
                color: #eb1700;

                &.none {
                  background-color: #eb1700;
                  color: #fff;
                  text-align: center;
                  width: 46px;
                  height: 18px;
                  min-width: 46px;
                  border-radius: 100px;
                }
              }
            }

            .item-unlock {
              display: flex;
              align-items: center;
              height: 20px;
              margin-top: 2px;

              .icon-unlock {
                width: 10px;
                margin-right: 4px;
                display: block;
              }

              .txt {
                color: #EB1700;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}

/deep/ .van-cell {
  padding: 0;
}

/deep/ .van-collapse-item__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/components/JourneyStageCollapse.vue